import _ from 'lodash'
import { post } from './nikan-api'
import Endpoints from '@nikan/endpoints'
import ReportParameters from '../views/reports/report-parameters.vue'
import DynamicReportViewer from '../views/reports/dynamic-report-viewer.vue'
import moment, { Moment } from "jalali-moment"
import Store from '../store/index'
import { IDRParameter, IQueryDesignerData, TDRParameterSmartDate, IDynamicReport, IReportExecuteResult } from '../interfaces/plugins/dynamic-report'

interface IExecutionRequestResult {
  errors: any[]
  success: boolean
  data: IReportExecuteResult
}

class DynamicReport {
  calculateParameters(parameters: IDRParameter[], settingParameters: IDRParameter[]) {
    if (parameters && parameters.length > 0) {
      return parameters.map(x => {
        let foundParameter = settingParameters && settingParameters.find(y => y.key == x.key)
        let value
        switch (x.type) {
          case 'guid':
            if (foundParameter?.value === 'currentCompany')
              value = Store.getters['appContext/getCompany'].id
            if (foundParameter?.value === 'currentFiscalPeriod')
              value = Store.getters['appContext/getFiscalPeriod'].id
            break
          case 'currentCompany':
            value = Store.getters['appContext/getCompany'].id
            break
          case 'currentFiscalPeriod':
            value = Store.getters['appContext/getFiscalPeriod'].id
            break
          case 'smartDate':
            value = this.calculateSmartDate(x.smartDate)
            break
          case 'currentDate':
            value = new Date()
            break
          default:
            value = x.value || foundParameter?.value
            break
        }

        return { ...x, value: value }
      })
    } else return []
  }

  calculateSmartDate(smartDateObj: TDRParameterSmartDate) {
    let timeDictionary: Record<string, moment.unitOfTime.DurationConstructor> = {
      day: 'days',
      week: 'weeks',
      month: 'months',
      year: 'years',
    }
    if (smartDateObj) {
      let faNow: Moment = moment().locale('fa')
      let faDateDirection: Moment
      if (smartDateObj?.direction == 'future')
        faDateDirection = faNow.add(smartDateObj.count, timeDictionary[smartDateObj.type])
      else
        faDateDirection = faNow.subtract(smartDateObj.count, timeDictionary[smartDateObj.type])

      let targetFaDate
      if (smartDateObj.startOrEnd == 'start') targetFaDate = faDateDirection.startOf(smartDateObj.type).format('YYYY/MM/DD')
      else targetFaDate = faDateDirection.endOf(smartDateObj.type).format('YYYY/MM/DD')
      let targetEnDate = moment.from(targetFaDate, 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')
      return targetEnDate
    }
  }

  callReportsDynamicApi(queryDesignerObject: IQueryDesignerData, reportData: IDynamicReport) {
    return post(Endpoints.getUrl('reportsDynamic.execute'), { queryDesigner: queryDesignerObject }).then((executeResult: IExecutionRequestResult) => {
      return {
        name: reportData.name,
        id: reportData.id,
        executeResult: executeResult.data
      }

    })
      .catch((e: any) => {
        throw e
      })
  }

  getDynamicReport(reportId: string) {
    return post(Endpoints.getUrl("reportsDynamic.get"), { id: reportId })
  }

  fillParameters(parameters: IDRParameter[], _this: any): Promise<IDRParameter[]> {
    return new Promise((resolve, reject) => {

      let resultParameters: IDRParameter[] = []

      const autoParametersTypes = ['smartDate', 'currentDate', 'currentCompany', 'currentFiscalPeriod']
      const allParametersAreAuto = parameters.every(parameter => autoParametersTypes.includes(parameter.type))

      if (parameters && parameters.length > 0 && !allParametersAreAuto) {
        _this.showModal({
          component: ReportParameters,
          data: parameters,
          options: {
            autoFields: autoParametersTypes
          }
        }).then((resultParameters: IDRParameter[]) => {
          const calculatedParams = this.calculateParameters(parameters, resultParameters)
          resolve(calculatedParams)
        }).catch((err: any) => err)
      }
      else {
        const calculatedParams = this.calculateParameters(parameters, resultParameters)
        resolve(calculatedParams)
      }
    })
  }

  getAndExecuteDynamicReport(reportId: string, _this: any) {
    return new Promise((resolve, reject) => {
      this.getDynamicReport(reportId).then((res: { data: IDynamicReport }) => {
        this.executeDynamicReport(res.data, _this).then((result) => {
          resolve(result)
        }).catch((err) => reject(err))
      }).catch((err: any) => {
        console.log(err)
      })
    })
  }

  async executeDynamicReport(reportData: IDynamicReport, _this: any) {
    let queryDesignerObject = JSON.parse(reportData.queryDesignerJson) as IQueryDesignerData
    try {
      const resultParameters = await this.fillParameters(queryDesignerObject.parameters, _this)
      queryDesignerObject.parameters = resultParameters
    }
    catch (e) {
      throw new Error('Report execution failed. Error:"Parameters"')
    }

    let wait = _this.$wait(_this.$el)
    try {
      const reportResult = await this.callReportsDynamicApi(queryDesignerObject, reportData)
      wait.end()
      return reportResult
    }
    catch {
      wait.end()
      throw new Error('Report execution failed. Error: "Server Execution"')
    }
  }

  launchDynamicReport(reportId: string, _this: any) {
    this.getDynamicReport(reportId).then((res: { data: IDynamicReport }) => {
      this.executeDynamicReport(res.data, _this).then((executionResult) => {
        this.showReportDataInModal(executionResult, _this)
      })
    }).catch((err: any) => {
      console.log(err)
    })
  }

  showReportDataInModal(dynamicReportData: { name: string, id: string, executeResult: IReportExecuteResult }, _this: any) {
    setTimeout(() => {
      _this.showModal({
        component: DynamicReportViewer,
        data: dynamicReportData
      }).then(() => { }).catch(() => { })
    }, 350)
  }
}

const dynamicReportInstance = new DynamicReport()

export { DynamicReport }
export default dynamicReportInstance